// GENERATED by @platform/contracts from specs/engagement/main.tsp. Do not edit; run `pnpm generate`.
/* eslint-disable */
import { createCaller } from '../../client/runtime.js';
import { operations } from './schemas.js';
export function createEngagementClient(options) {
    const call = createCaller(options);
    return {
        /** The tenant's consent ledger: the current state per subject and channel. */
        Consent_list: (input = {}) => call(operations.Consent_list, input),
        /** Record an opt-in or opt-out by hand (a verbal request, a written one). Appends to the history. */
        Consent_add: (input) => call(operations.Consent_add, input),
        /** The caller's phones registered for push notifications in this workspace. */
        Devices_list: (input = {}) => call(operations.Devices_list, input),
        /** Register the caller's phone for push. The same token again is the same device, refreshed. */
        Devices_register: (input) => call(operations.Devices_register, input),
        /** Stop push notifications to one of the caller's phones. */
        Devices_remove: (input) => call(operations.Devices_remove, input),
        /** The caller's current notices, newest first: not withdrawn, not expired; acknowledged ones included. */
        Notices_list: (input = {}) => call(operations.Notices_list, input),
        /** The caller acknowledges one notice as themselves. Idempotent: the first time is kept. */
        Notices_acknowledge: (input) => call(operations.Notices_acknowledge, input),
        /** Messages engagement delivered (or tried to) for the caller's tenant, newest first. */
        Notifications_list: (input = {}) => call(operations.Notifications_list, input),
        /** One message and its delivery state. */
        Notifications_get: (input) => call(operations.Notifications_get, input),
        /** The caller's notification preferences in this workspace. */
        Preferences_get: (input = {}) => call(operations.Preferences_get, input),
        /** Turn push notifications on or off for the caller in this workspace. */
        Preferences_update: (input) => call(operations.Preferences_update, input),
    };
}
//# sourceMappingURL=client.js.map